module.exports = __webpack_public_path__ + "img/vacunas7.0e998cf5.jpg";